import { computed } from 'vue';
import isFirefoxFn from '@/utilities/isFirefox';

export default function useIsBrowser() {
  const isFirefox = computed(() => isFirefoxFn());
  const isSafari = computed(() => /^((?!chrome|android).)*safari/i.test(navigator?.userAgent));
  const isChromium = computed(() => !!(window as any).chrome);

  return { isFirefox, isSafari, isChromium };
}
